module.exports = __webpack_public_path__ + "static/media/bg-bawah.227a39e6.png";